import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import ToolPassportModal from "../Generic/ToolPassportModal";

function HomeTools() {
  const { subcategoryId, categoryId, panelId } = useParams();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [tools, setTools] = useState([]);
  // New modal state for showing row details
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleOpenModal = async (toolId) => {
    const res = await axiosPrivate.get(`/ToolPassports/Public/${toolId}`);
    setSelectedRow(res.data);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedRow(null);
  };

  useEffect(() => {
    if (!subcategoryId) return;
    const loadTools = async () => {
      try {
        const res = await axiosPrivate.get(`/ToolPassports/Public/BySubcategory/${subcategoryId}`);
        if (typeof res.data === "string" && res.data === "No records") {
          setTools([]);
        } else {
          setTools(res.data);
        }
      } catch (err) {
        enqueueSnackbar("Cannot load tools", { variant: "error" });
      }
    };
    loadTools();
  }, [subcategoryId, axiosPrivate, enqueueSnackbar]);

  const handleToolSelection = async () => {
    navigate("/ToolSelection/Selection/" + panelId + "/" + categoryId + "/" + subcategoryId);
  };

  return (
    <>
      <div className="container px-3 overflow-hidden">
        <div className="row text-center">
          <h1>Welcome to Online-CADCOM</h1>
          <p>Online assisted Platform for Computer-aided design in communications</p>
          <a className="fw-bold newPrimaryBlue myLink my-1"
            href={`/ToolSelection/Selection/${panelId}/${categoryId}/${subcategoryId}`}>Go to "Tool Selection"</a>
        </div>
        <div className="row justify-content-center">
          {tools && (
            tools.map((tool) => (
              <div key={tool.id} className="col-12 col-md-4 d-flex justify-content-center mb-2">
                <div className="card text-center" style={{ width: "28rem", minHeight: "10rem" }}>
                  <div className="card-body">
                    <img
                      src={tool.logo ? `${process.env.REACT_APP_SERVER_URLForLogo}/${tool.logo}` : `/assets/brand/default_img.png`}
                      alt="logo"
                      style={{ width: '75px', height: '50px', objectFit: 'contain' }}
                      onError={(e) => { e.target.onerror = null; e.target.src = '/default-logo.png'; }}
                    />
                    <h5 className="card-title">{tool.name}</h5>
                    <p className="card-text">{tool.categoryName} <br /> ({tool.subcategoryName})</p>
                    {/* <p className="card-text">{tool.subcategoryName}</p> */}
                    <span className="btn btn-primary" onClick={() => handleOpenModal(tool.id)}>{t("viewToolPassport")}</span>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      {/* Modal for displaying tool passport details */}
      <ToolPassportModal
        open={openModal}
        onClose={handleCloseModal}
        toolPassport={selectedRow}
      />
    </>
  );
}

export default HomeTools;